import { render, staticRenderFns } from "./SimpleMarkdown.vue?vue&type=template&id=729ed85c&scoped=true&"
import script from "./SimpleMarkdown.vue?vue&type=script&lang=js&"
export * from "./SimpleMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ed85c",
  null
  
)

export default component.exports